export default {
    "id": "find-a-doctor",
    "name": "搜尋醫生",
    "style": "dropdown-one-after-another",
    "children": [
        {
            "id": "vc",
            "name": "視像問診",
            "href": "https://www.finddoc.com/vc"
        },
        {
            "id": "tab-specialties",
            "name": "專科醫生搜尋",
            "children": [
                {
                    "id": "53",
                    "name": "普通科醫生",
                    "href": "https://www.finddoc.com/doctors/%E6%99%AE%E9%80%9A%E7%A7%91%E9%86%AB%E7%94%9F"
                },
                {
                    "id": "33",
                    "name": "婦產科醫生",
                    "href": "https://www.finddoc.com/doctors/%E5%A9%A6%E7%94%A2%E7%A7%91%E9%86%AB%E7%94%9F"
                },
                {
                    "id": "12",
                    "name": "皮膚及性病科醫生",
                    "href": "https://www.finddoc.com/doctors/%E7%9A%AE%E8%86%9A%E5%8F%8A%E6%80%A7%E7%97%85%E7%A7%91%E9%86%AB%E7%94%9F"
                },
                {
                    "id": "54",
                    "name": "牙醫",
                    "href": "https://www.finddoc.com/doctors/%E7%89%99%E9%86%AB"
                },
                {
                    "id": "37",
                    "name": "耳鼻喉科醫生",
                    "href": "https://www.finddoc.com/doctors/%E8%80%B3%E9%BC%BB%E5%96%89%E7%A7%91%E9%86%AB%E7%94%9F"
                },
                {
                    "id": "35",
                    "name": "眼科醫生",
                    "href": "https://www.finddoc.com/doctors/%E7%9C%BC%E7%A7%91%E9%86%AB%E7%94%9F"
                },
                {
                    "id": "56",
                    "name": "中醫師",
                    "href": "https://www.finddoc.com/doctors/%E4%B8%AD%E9%86%AB%E5%B8%AB"
                }
            ],
            "corner": {
                "id": "view-all",
                "name": "所有專科醫生",
                "href": "https://www.finddoc.com/specialties"
            }
        },
        {
            "id": "tab-district",
            "name": "地區醫生搜尋",
            "children": [
                {
                    "id": "7",
                    "name": "中環醫生",
                    "href": "https://www.finddoc.com/doctors/%E4%B8%AD%E7%92%B0"
                },
                {
                    "id": "32",
                    "name": "尖沙咀醫生",
                    "href": "https://www.finddoc.com/doctors/%E5%B0%96%E6%B2%99%E5%92%80"
                },
                {
                    "id": "30",
                    "name": "旺角醫生",
                    "href": "https://www.finddoc.com/doctors/%E6%97%BA%E8%A7%92"
                },
                {
                    "id": "12",
                    "name": "銅鑼灣醫生",
                    "href": "https://www.finddoc.com/doctors/%E9%8A%85%E9%91%BC%E7%81%A3"
                },
                {
                    "id": "29",
                    "name": "佐敦醫生",
                    "href": "https://www.finddoc.com/doctors/%E4%BD%90%E6%95%A6"
                },
                {
                    "id": "73",
                    "name": "屯門醫生",
                    "href": "https://www.finddoc.com/doctors/%E5%B1%AF%E9%96%80"
                },
                {
                    "id": "59",
                    "name": "荃灣醫生",
                    "href": "https://www.finddoc.com/doctors/%E8%8D%83%E7%81%A3"
                }
            ],
            "corner": {
                "id": "view-all",
                "name": "所有專科醫生",
                "href": "https://www.finddoc.com/specialties"
            }
        },
        {
            "id": "tab-buildings",
            "name": "香港醫生集中地",
            "children": [
                {
                    "id": "62",
                    "name": "旺角中心1期醫生",
                    "href": "https://www.finddoc.com/buildings/%E6%97%BA%E8%A7%92%E4%B8%AD%E5%BF%831%E6%9C%9F-62"
                },
                {
                    "id": "75",
                    "name": "亞太中心醫生",
                    "href": "https://www.finddoc.com/buildings/%E4%BA%9E%E5%A4%AA%E4%B8%AD%E5%BF%83-75"
                },
                {
                    "id": "6",
                    "name": "養和醫院醫生",
                    "href": "https://www.finddoc.com/buildings/%E9%A4%8A%E5%92%8C%E9%86%AB%E9%99%A2-6"
                },
                {
                    "id": "48",
                    "name": "中建大廈醫生",
                    "href": "https://www.finddoc.com/buildings/%E4%B8%AD%E5%BB%BA%E5%A4%A7%E5%BB%88-48"
                },
                {
                    "id": "1",
                    "name": "嘉賓商業大廈醫生",
                    "href": "https://www.finddoc.com/buildings/%E5%98%89%E8%B3%93%E5%95%86%E6%A5%AD%E5%A4%A7%E5%BB%88-1"
                },
                {
                    "id": "8",
                    "name": "萬邦行醫生",
                    "href": "https://www.finddoc.com/buildings/%E8%90%AC%E9%82%A6%E8%A1%8C-8"
                },
                {
                    "id": "332",
                    "name": "海洋中心醫生",
                    "href": "https://www.finddoc.com/buildings/%E6%B5%B7%E6%B4%8B%E4%B8%AD%E5%BF%83-332"
                }
            ],
            "corner": {
                "id": "view-all",
                "name": "所有醫生集中地",
                "href": "https://www.finddoc.com/buildings"
            }
        },
        {
            "id": "tab-hospitalAffiliations",
            "name": "香港醫院名單",
            "children": [
                {
                    "id": "16",
                    "name": "嘉諾撒醫院",
                    "href": "https://www.finddoc.com/hospital-affiliations/%E5%98%89%E8%AB%BE%E6%92%92%E9%86%AB%E9%99%A2-16"
                },
                {
                    "id": "20",
                    "name": "養和醫院",
                    "href": "https://www.finddoc.com/hospital-affiliations/%E9%A4%8A%E5%92%8C%E9%86%AB%E9%99%A2-20"
                },
                {
                    "id": "23",
                    "name": "香港浸信會醫院",
                    "href": "https://www.finddoc.com/hospital-affiliations/%E9%A6%99%E6%B8%AF%E6%B5%B8%E4%BF%A1%E6%9C%83%E9%86%AB%E9%99%A2-23"
                },
                {
                    "id": "40",
                    "name": "明德國際醫院",
                    "href": "https://www.finddoc.com/hospital-affiliations/%E6%98%8E%E5%BE%B7%E5%9C%8B%E9%9A%9B%E9%86%AB%E9%99%A2-40"
                },
                {
                    "id": "60",
                    "name": "聖保祿醫院",
                    "href": "https://www.finddoc.com/hospital-affiliations/%E8%81%96%E4%BF%9D%E7%A5%BF%E9%86%AB%E9%99%A2-60"
                },
                {
                    "id": "61",
                    "name": "聖德肋撒醫院",
                    "href": "https://www.finddoc.com/hospital-affiliations/%E8%81%96%E5%BE%B7%E8%82%8B%E6%92%92%E9%86%AB%E9%99%A2-61"
                },
                {
                    "id": "70",
                    "name": "仁安醫院",
                    "href": "https://www.finddoc.com/hospital-affiliations/%E4%BB%81%E5%AE%89%E9%86%AB%E9%99%A2-70"
                }
            ],
            "corner": {
                "id": "view-all",
                "name": "所有醫院",
                "href": "https://www.finddoc.com/hospital-affiliations"
            }
        },
        {
            "id": "practices",
            "name": "香港診所名單",
            "href": "https://www.finddoc.com/practices"
        }
    ]
}